export default "__VITE_ASSET__d_g6QLAb__"